export type Step = {
  id: string;
  name: string;
  isComplete?: boolean;
};

export type StepperState = {
  activeStep: number;
  steps: Step[];
};

export enum StepperVariant {
  DEFAULT = 'DEFAULT',
  BAR = 'BAR',
}
